<template>
	<div class="MembershipDuesWarp">
		<!-- <div class="titleBox">培训课程管理</div> -->
		<div class="duesTabBox">
			<div class="activcourseItem">
				会费缴纳
			</div>
			<!-- <div class="search-box">
				<el-input type="text" v-model="searchVal" placeholder="请输入搜索内容" @keydown.enter.native="serchEnterFn" clearable>
					<i slot="prefix" class="el-input__icon el-icon-search"></i>
				</el-input>
			</div> -->
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" border :header-cell-style="tableHeaderColor">
				<el-table-column prop="duesYear" label="缴费年度" width="150" align="center"></el-table-column>
				<el-table-column  label="会员等级" align="center">
					<template slot-scope="scope">
						<div >
							{{scope.row.memberlevel?scope.row.memberlevel:'-'}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="duesMoneyPlay" label="会费标准" align="center"></el-table-column>
				<el-table-column prop="duesTime" label="缴费时间" width="220" align="center"></el-table-column>
				<el-table-column prop="duesMoney" label="缴费金额" align="center"></el-table-column>
				<el-table-column prop="isDues" label="会费缴纳情况" align="center"></el-table-column>
				<el-table-column label="票据开具" width="200" fixed="right" align="center">
					<template slot-scope="scope">
						<div class="handle_warp">
							<div class="openticket" v-if="scope.row.billAudit==1">已开具</div>
							<div class="hasapply" v-else-if="scope.row.billAudit==0" @click="seeTickeFn(scope.row)">已申请</div>
							<div class="applyticket" v-else @click="applyTickeFn(scope.row)">申请开票</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->        
			<div class="paging_warp">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 15, 20]"
				:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
			</div>
		</div>
		<!-- 弹框 -->
		<el-dialog title="开票" :visible.sync="ticketFormVisible" width="720px" class="dialogWarp" :append-to-body='true' :center="true"
		    :destroy-on-close="true" :close-on-click-modal='false' :show-close="false">
			<el-form :model="form" label-width='140px' :rules='formRules' ref="form">
				<div class="formtitlebox">开票信息</div>
				<el-form-item label="单位名称" prop='corpName'>
					<el-input v-model="form.corpName"></el-input>
				</el-form-item>
				<el-form-item label="统一社会信用代码" prop='organizingCord'>
					<el-input v-model="form.organizingCord"></el-input>
				</el-form-item>
				<!-- <el-form-item label="开票内容" prop='billContent'>
					<el-input v-model="form.billContent"></el-input>
				</el-form-item> -->
				<el-form-item label="备注" prop='remark'>
					<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="form.remark">
					</el-input>
				</el-form-item>
				<div class="formtitlebox">收票人信息</div>
				<el-form-item label="收票人姓名" prop='linkman'>
					<el-input v-model="form.linkman"></el-input>
				</el-form-item>
				<el-form-item label="收票人手机号" prop='phone'>
					<el-input v-model="form.phone"></el-input>
				</el-form-item>
				<el-form-item label="收票人邮箱" prop='billemail'>
					<el-input v-model="form.billemail"></el-input>
				</el-form-item>
				<div class="formBtnBox" v-if="btntype=='待申请'">
					<el-button type="primary" @click="submitForm('form')" class="submitBtn">确 定</el-button>
					<el-button @click="cancelform" class="cancelBtn">取消</el-button>
				</div>
				<div class="formBtnBox" v-else>
					<el-button @click="cancelform" class="cancelBtn">关闭</el-button>
				</div>
			</el-form>
			<!-- <div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="ticketFormVisible = false">确 定</el-button>
				<el-button @click="ticketFormVisible = false">取 消</el-button>
			</div> -->
		</el-dialog>
	</div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
	components: {
	},
	data() {
		return {
			srcUrl: srcUrl,
			tableData: [],
			currentPage: 1,
			// 每页显示条数
			pageSize: 10,
			// 总条数
			total: 0,
			ticketFormVisible: false,
			form: {
				corpName: '',
				linkman: '',
				phone: '',
				billemail: '',
				// billContent: '',
				remark: '',
				organizingCord: '',
			},
			formRules: {
				// billContent: [
				// 	{ required: true, message: '开票内容不能为空', trigger: 'blur' }
				// ],
				organizingCord: [
					{ required: true, message: '统一社会信用代码不能为空', trigger: 'blur' }
				],
				corpName: [
					{ required: true, message: '单位名称不能为空', trigger: 'blur' }
				],
				// corpName: [
				// 	{ required: true, message: '统一社会信用代码不能为空', trigger: 'blur' }
				// ],
				// corpName: [
				// 	{ required: true, message: '开票内容不能为空', trigger: 'blur' }
				// ],
				linkman: [
					{ required: true, message: '收票人姓名不能为空', trigger: 'blur' }
				],
				phone: [
					{
						required: true, message: '手机号码不能为空', trigger: 'blur'
					},
					{
						required: true, message: '请输入正确的手机号码', pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur'
					}
				],
				billemail: [
					{ required: true, message: '请输入邮箱地址', trigger: 'blur' },
					{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
				],
			},
			searchVal: '',
			userId: '',
			duesdata: '',//会费缴纳id
			btntype: ''
		}
	},
	created() {
		if (JSON.parse(sessionStorage.getItem('userInfo'))) {
			this.userId = JSON.parse(sessionStorage.getItem('userInfo')).userId
		}
	},
	mounted() {
		this.getList()
		// this.$nextTick(() => {
		// 	// DOM 更新了
		// 	this.$refs["form"].clearValidate()
		// })
	},
	methods: {
		// 获取列表
		async  getList() {
			let params = {
				pageSize: this.pageSize,
				pageCurrent: this.currentPage,
				audit: this.audit,
				userId: this.userId,
			};
			let data = await httpService.getDuesLog(params);
			if (data.code == 200) {
				this.tableData = data.result.list
				this.total=data.result.total
			}
		},
		// 开票弹框
		applyTickeFn(val) {
			this.duesdata = val
			this.ticketFormVisible = true
			this.btntype = '待申请'
		},
		seeTickeFn(val) {
			this.duesdata = val
			this.ticketFormVisible = true
			this.btntype = '已申请'
			this.getBillFn()
		},
		async getBillFn() {
			if (this.duesdata.billId) {
				let data = await httpService.getBill(this.duesdata.billId);
				if (data.code == 200) {
					this.form = data.result
				}
			}
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.form.userId = this.userId
					this.form.duesId = this.duesdata.duesId
					httpService.addDuesBill(this.form).then(res => {
						if (res.code == 200) {
							this.$message({
								message: '开票申请已提交成功',
								type: 'success'
							});
							this.getList()
							// 重置表单
							this.$refs[formName].resetFields();
							this.ticketFormVisible = false
							
						}else{
							this.$message.error(res.message);
						}
					})
				} else {
					return false;
				}
			});
		},
		cancelform() {
			this.ticketFormVisible = false
			// 重置表单
			this.$refs['form'].resetFields();
			this.getList()
		},
		tableHeaderColor() {
			return "background-color:#FAFAFA;color:rgba(0,0,0,0.85);border-bottom:1px solid #FAFAFA;font-weight:900;height:55px";
		},
		// 分页
		async handleSizeChange(val) {
			this.pageSize = val;
			this.getList()
		},
		async handleCurrentChange(val) {
			this.currentPage = val;
			this.getList()
		},
		opendialog() {
			this.ticketFormVisible = true
		},
		serchEnterFn(e) {
			let keyCode = window.event ? e.keyCode : e.which;
			if (keyCode == 13) {
				this.searchFn();
			}
		},
	},
	filters: {
		timer: (value) => {
			return value.substring(0, 10);
		},
	},
}
</script>
<style lang="less" scoped>
.MembershipDuesWarp {
	width: 100%;
	box-sizing: border-box;
	padding: 22px 61px 0 50px;
	.titleBox {
		font-size: 24px;
		font-weight: bold;
		line-height: 24px;
		color: #43424b;
		margin-bottom: 32px;
	}
	.duesTabBox {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		font-size: 16px;
		padding: 0 0 5px 0px;
		border-bottom: 1px solid #0083ff;
		.activcourseItem {
			width: 124px;
			height: 42px;
			line-height: 42px;
			background: #349cff;
			border-radius: 5px;
			text-align: center;
			color: #fff;
			cursor: pointer;
		}
		// 搜索框
		.search-box {
			// background: #1088fe;
			width: 256px;
			justify-content: center;
			align-items: center;
			align-content: center;
			text-align: center;
			// padding: 30px 0px;
			display: flex;
			flex-direction: row;
			margin-left: 32px;
			/deep/.el-input__inner {
				// background-color: #68b4ff;
				border: 1px solid rgba(56, 67, 100, 0.2);
				color: #000 !important;
				border-radius: 27px;
				padding-left: 55px;
			}
			/deep/input::placeholder {
				color: #cfd0d6 !important;
			}
			.el-icon-search {
				font-size: 21px;
				padding: 0 0px 0 18px;
				cursor: pointer;
				color: #384364;
			}
		}
	}

	.handle_warp {
		font-size: 16px;
		display: flex;
		flex-direction: row;
		justify-content: center;
		.applyticket {
			color: #0083ff;
			cursor: pointer;
		}
		.openticket {
			color: #52ca9c;
		}
		.hasapply {
			color: #e3ac4f;
			cursor: pointer;
		}
	}
	.tableBox {
		.paging_warp {
			text-align: center;
			position: fixed;
			bottom: 40px;
			left: 50%;
		}
	}
	/deep/.el-dialog__header {
		height: 45px;
		background: rgba(0, 131, 255, 0.33);
		border-radius: 0px 0px 8px 8px;
		padding: 0 0 0 28px;
		display: flex;
		flex-direction: row;
		align-items: center;
		position: relative;

		.el-dialog__title {
			color: #fff;
		}
		.el-dialog__headerbtn {
			position: absolute;
			top: 0;
			right: 0;
			width: 64px;
			height: 45px;
			background: rgba(52, 156, 255, 0.39);
			border: 1px solid rgba(0, 0, 0, 0);
			border-radius: 0 0 10px 10px;

			.el-dialog__close {
				color: #fff;
				font-size: 20px;
			}
		}
	}
	/deep/.el-dialog__footer {
		text-align: center;
		.el-button {
			width: 152px;
			height: 40px;
			margin: 0 20px;
		}
	}
	.formtitlebox {
		font-size: 18px;
		line-height: 54px;
		color: #43424b;
		margin-right: 550px;
		text-align: right;
	}
}
</style>


<style lang="less">
.dialogWarp {
	/deep/.el-dialog__header {
		height: 45px;
		background: rgba(0, 131, 255, 0.33);
		border-radius: 0px 0px 8px 8px;
		padding: 0 0 0 28px;
		display: flex;
		flex-direction: row;
		align-items: center;
		position: relative;

		.el-dialog__title {
			color: #fff;
		}

		.el-dialog__headerbtn {
			position: absolute;
			top: 0;
			right: 0;
			width: 64px;
			height: 45px;
			background: rgba(52, 156, 255, 0.39);
			border: 1px solid rgba(0, 0, 0, 0);
			border-radius: 0 0 10px 10px;

			.el-dialog__close {
				color: #fff;
				font-size: 20px;
			}
		}
	}
	/deep/.el-dialog__footer {
		text-align: center;
		// padding-bottom: 30px;
		.el-button {
			width: 152px;
			height: 40px;
			margin: 0 20px;
		}
	}
	.formBtnBox {
		display: flex;
		fill-opacity: row;
		justify-content: center;
		.submitBtn {
			width: 152px;
			height: 40px;
			background: #349cff;
			margin: 0 20px;
		}
		.submitdraftBtn {
			width: 152px;
			height: 40px;
			background: #52ca9c;
			margin: 0 20px;
			color: #fff;
		}
		.cancelBtn {
			width: 152px;
			height: 40px;
			border: 1px solid #a6a9b7;
			border-radius: 5px;
			margin: 0 20px;
		}
	}
}
</style>